import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { CheckCircle, AlertTriangle } from 'lucide-react';

export function ContabResultModal({ open, data, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {data?.errores === 0
              ? <><CheckCircle className="w-5 h-5 text-green-600" /> Exitosa</>
              : <><AlertTriangle className="w-5 h-5 text-amber-600" /> Resultado</>}
          </DialogTitle>
        </DialogHeader>
        {data && (
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-3">
              <div className="bg-green-50 border border-green-200 rounded p-3 text-center">
                <p className="text-xs text-green-700">Exitosos</p>
                <p className="text-2xl font-bold text-green-700">{data.exitosos}</p>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded p-3 text-center" data-testid="contab-con-avisos">
                <p className="text-xs text-amber-700">Con ítems sin familia</p>
                <p className="text-2xl font-bold text-amber-700">{data.con_avisos || 0}</p>
              </div>
              <div className="bg-red-50 border border-red-200 rounded p-3 text-center">
                <p className="text-xs text-red-700">Errores</p>
                <p className="text-2xl font-bold text-red-700">{data.errores}</p>
              </div>
            </div>
            {data.resultados?.length > 0 && (
              <div className="space-y-1.5" data-testid="contab-result-details">
                {data.resultados.map((r, i) => (
                  <div key={`result-${r.folio}-${i}`} className={`text-xs rounded px-2.5 py-1.5 border ${
                    r.status !== 'ok' ? 'bg-red-50 border-red-200' : (r.avisos?.length ? 'bg-amber-50 border-amber-200' : 'bg-green-50 border-green-200')
                  }`}>
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="font-mono font-bold">{r.folio}</span>
                        {r.status === 'ok' && r.adjuntos?.length > 0 && (
                          <span className="ml-2 text-[10px] text-blue-600">
                            Adjuntos: {r.adjuntos.join(', ')}
                          </span>
                        )}
                        {r.status === 'error' && (
                          <span className="ml-2 text-red-600 truncate max-w-[250px] inline-block align-bottom" title={r.error}>
                            {r.error?.substring(0, 80)}
                          </span>
                        )}
                      </div>
                      {r.status === 'ok'
                        ? (r.avisos?.length ? <AlertTriangle className="w-3.5 h-3.5 text-amber-600 flex-shrink-0" /> : <CheckCircle className="w-3.5 h-3.5 text-green-600 flex-shrink-0" />)
                        : <AlertTriangle className="w-3.5 h-3.5 text-red-600 flex-shrink-0" />}
                    </div>
                    {r.avisos?.length > 0 && (
                      <div className="mt-1 text-[11px] text-amber-800" data-testid={`contab-aviso-${r.folio}`}>
                        {r.avisos.map((a, j) => <p key={j}>{a}</p>)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cerrar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
